import BrandsIndex from '@/views/BrandsIndex.vue';
import BrandsCreate from '@/views/BrandsCreate.vue';
import BrandsEdit from '@/views/BrandsEdit.vue';

const routes = [
    {
        path: '/brands',
        name: 'BrandsIndex',
        component: BrandsIndex,
        meta: { layout: 'DashboardLayout' }
    },
    {
        path: '/brands/create',
        name: 'BrandsCreate',
        component: BrandsCreate,
        meta: { layout: 'DashboardLayout' }
    },
    {
        path: '/brands/:id',
        name: 'BrandsEdit',
        component: BrandsEdit,
        meta: { layout: 'DashboardLayout' }
    }
];

export default routes
